import { BehaviorSubject, Subject, Observable } from 'rxjs';

import { ISnComponentOrTemplateConfig } from '@lib/common/interfaces';
import { SnComponentOrTemplate } from '@lib/common/types';
import { SnActionConfig } from '@lib/ui/actions';

export class SnLayoutAppbarActionsReference {
  private readonly _change$ = new BehaviorSubject<SnActionConfig[]>([]);

  // TODO: temporary solution for chats
  private readonly _componentOrTemplate$ = new Subject<SnComponentOrTemplate>();
  private readonly _componentOrTemplateConfig$ = new Subject<ISnComponentOrTemplateConfig>();

  constructor() {}

  get change$(): Observable<SnActionConfig[]> {
    return this._change$.asObservable();
  }

  get componentOrTemplate$(): Observable<SnComponentOrTemplate> {
    return this._componentOrTemplate$.asObservable();
  }

  get componentOrTemplateConfig$(): Observable<ISnComponentOrTemplateConfig> {
    return this._componentOrTemplateConfig$.asObservable();
  }

  public onDestroy(): void {
    this._change$.complete();
  }

  public set(actions: SnActionConfig[]): void {
    this._change$.next(actions);
  }

  public setComponentOrTemplate(
    componentOrTemplate: SnComponentOrTemplate,
    config?: ISnComponentOrTemplateConfig,
  ): void {
    this._componentOrTemplate$.next(componentOrTemplate);
    this._componentOrTemplateConfig$.next(config);
  }

  public clear(): void {
    this._change$.next([]);
    this._componentOrTemplate$.next(null);
    this._componentOrTemplateConfig$.next(null);
  }
}
